import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import styled from "styled-components";
import playSound from "@/sound";
import anime from "animejs/lib/anime.es.js";
import { blockTouch, randomRange } from "@stores/vars";
import Confetti from "./Confetti";

const Wrap = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  .char {
    opacity: 0;
    position: absolute;
    left: 310px;
    top: 495px;
    width: 400px;
    height: 400px;
  }
`;

const Title = styled.div`
  position: absolute;
  width: 714px;
  height: 246px;
  background: url(${require("@assets/img/cardgame/result_title.png")}) no-repeat;
  background-size: 100% 100%;
  left: 50%;
  top: 190px;
  margin-left: -357px;
  opacity: 0;
`;

const Badge = styled.div`
  position: absolute;
  width: 367px;
  height: 600px;
  left: 50%;
  top: 280px;
  margin-left: -190px;
  opacity: 0;
  &.r1 {
    background: url(${require("@assets/img/cardgame/rank1.png")}) no-repeat;
    background-size: 100% 100%;
  }
  &.r2 {
    background: url(${require("@assets/img/cardgame/rank2.png")}) no-repeat;
    background-size: 100% 100%;
  }
  &.r3 {
    background: url(${require("@assets/img/cardgame/rank3.png")}) no-repeat;
    background-size: 100% 100%;
  }
`;

const ButtonWrap = styled.div`
  position: absolute;
  left: 50%;
  bottom: 90px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}
`;

const ReStartButton = styled.button`
  width: 335px;
  height: 128px;
  background: url(${require("@assets/img/cardgame/restart.png")}) no-repeat;
  background-size: 100% 100%;
  margin-right: 10px;
`;

const EndButton = styled.button`
  width: 335px;
  height: 128px;
  background: url(${require("@assets/img/cardgame/end.png")}) no-repeat;
  background-size: 100% 100%;
  margin-left: 10px;
`;

const Score = styled.div`
  font-size: 100px;
  letter-spacing: 2px;
  font-weight: bold;
  color: #ffee00;
  position: absolute;
  right: 320px;
  top: 660px;
`;

const gameEndM = [
  require("@data/assets/_static/sounds/game_end_m1.mp3"),
  require("@data/assets/_static/sounds/game_end_m2.mp3"),
];
const gameEndW = [
  require("@data/assets/_static/sounds/game_end_w1.mp3"),
  require("@data/assets/_static/sounds/game_end_w2.mp3"),
];

const char_m = [
  require("@data/assets/_static/welcome_m1.png"),
  require("@data/assets/_static/welcome_m2.png"),
  require("@data/assets/_static/welcome_m3.png"),
  require("@data/assets/_static/welcome_m4.png"),
];
const char_w = [
  require("@data/assets/_static/welcome_w1.png"),
  require("@data/assets/_static/welcome_w2.png"),
  require("@data/assets/_static/welcome_w3.png"),
];

const GameCompletePop = ({ onRestartClick, onEndClick, score }) => {
  const titleRef = useRef(null);
  const badgeRef = useRef(null);
  const buttonWrapRef = useRef(null);
  const scoreRef = useRef(null);
  const welcomeImg =
    window.__welcomeRandom[0] === true
      ? char_m[window.__welcomeRandom[1]]
      : char_w[window.__welcomeRandom[1]];

  const getClass = () => {
    if (score >= 9) {
      return "r1";
    } else if (score >= 5) {
      return "r2";
    } else {
      return "r3";
    }
  };

  useEffect(() => {
    blockTouch();
    playSound.effect(require("@assets/sounds/effects/activity_end.mp3"));
    playSound.wordStop();

    if (score > 0) {
      if (window.__welcomeRandom[0]) {
        playSound.word(gameEndM[randomRange(0, 1)]);
      } else {
        playSound.word(gameEndW[randomRange(0, 1)]);
      }
    } else {
      blockTouch(false);
    }

    anime({
      targets: titleRef.current,
      scale: [2.4, 1],
      opacity: [0, 1],
      easing: "easeOutBack",
      duration: 600,
    });

    anime({
      targets: badgeRef.current,
      scale: [2, 1],
      opacity: [0, 1],
      delay: 200,
      easing: "easeOutBack",
      duration: 600,
    });

    anime({
      targets: "#cChar",
      scale: [2, 1],
      opacity: [0, 1],
      delay: 300,
      easing: "easeOutBack",
      duration: 600,
    });

    anime({
      targets: buttonWrapRef.current,
      opacity: [0, 1],
      delay: 500,
      easing: "easeOutBack",
      duration: 600,
    });

    anime({
      targets: scoreRef.current,
      opacity: [0, 1],
      translateX: [400, 0],
      delay: 500,
      easing: "easeOutCubic",
      duration: 600,
      complete: () => {
        blockTouch(false);
      },
    });

    return () => {
      playSound.wordStop();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrap>
      <Confetti isStart={true} />
      <Badge ref={badgeRef} className={getClass()} />
      <Title ref={titleRef} />
      <Score ref={scoreRef}>{`${score}개 성공!`}</Score>
      <ButtonWrap ref={buttonWrapRef}>
        <ReStartButton type="button" onClick={onRestartClick} />
        <EndButton type="button" onClick={onEndClick} />
      </ButtonWrap>
      <img src={welcomeImg} alt="" className="char" id="cChar" />
    </Wrap>
  );
};

export default GameCompletePop;
